/* eslint-disable react/no-unescaped-entities */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-eval */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
import React, {
  useCallback,
  useRef,
  useState,
  useEffect,
  useMemo,
} from 'react';
import { useParams, Link } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { FaTrash } from 'react-icons/fa';
import * as ts from 'typescript';
import { isValidCpf } from '../../../../utils/isValidCpf';
import { Container, Title, SubTitle, Card } from './styles';
import { useToast } from '../../../../hooks/toast';
import Button from '../../../../components/Button';

import Checkbox from '../../../../components/Checkbox';

import InputOutlined from '../../../../components/InputOutLined';
import SelectOutLined from '../../../../components/SelectOutLined';
import TarifasModal from '../TarifasModal';
import EmployeeService from '../../../../services/employee';
import DepartamentosService, {
  Departamento,
} from '../../../../services/departamentos';
import { Employee } from '../../../../interfaces/employee';
import Loader from '../../../../components/Loader';

import getValidationErrors from '../../../../utils/getValidationErrors';
import {
  Row,
  Column,
  InfoContainer,
  InfoItem,
  IconContainer,
} from '../../../../styles/components';

interface EditParams {
  id: string;
}

const EditEmployee: React.FC = () => {
  const service = { EmployeeService: new EmployeeService() };
  const serviceDepto = { DepartamentosService: new DepartamentosService() };
  const formRef = useRef<FormHandles>(null);
  const formTarifasRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const [loader, setLoader] = useState<boolean>(false);
  const [showTarifas, setShowTarifas] = useState<boolean>(false);

  const [employee, setEmployee] = useState<Employee>({} as Employee);

  const [addTarifas, setAddTarifas] = useState<any>([]);
  const [departamento, setDepartamento] = useState<Departamento>();
  const [departamentos, setDepartamentos] = useState<Departamento[]>(
    [] as Departamento[],
  );
  const [tarifas, setTarifas] = useState<any>(null);
  const [statusChecked, setStatusChecked] = useState<boolean>();
  const [tarifasDoFuncionario, setTarifasDoFuncionario] = useState<any[]>([]);

  const { id } = useParams<EditParams>();
  const schema = Yup.object().shape({
    Nome: Yup.string()
      .required('Nome é obrigatório')
      .test('nome-validation', 'Nome obrigatório', (value: any) => {
        if (!value) {
          document.getElementById('Nome')?.focus();
        }

        return value;
      }),
    Matricula: Yup.string()
      .required(
        'Esse campo é obrigatório. Caso não haja um número de matrícula utilize o CPF.',
      )
      .test('matricula-validation', 'Matricula obrigatória', (value: any) => {
        if (!value) {
          document.getElementById('Matricula')?.focus();
        }

        return value;
      }),
    FuncCpf: Yup.string().test(
      'cpf-validation',
      'CPF Inválido',
      (value: any) => {
        const isValid = isValidCpf(value);
        if (!value) {
          return true;
        }
        return isValid;
      },
    ),
    /* .required('CPF é obrigatório'), */
    // CodigoDepartamento: Yup.string().required('Departamento é obrigatório'),
    // Telefone: Yup.string().max(15, 'O número Máximo de caractéres é 15'),
  });

  const handleRemoveTarifa = useCallback(
    async (index: any) => {
      await setAddTarifas([]);
      const arr = addTarifas;
      arr.splice(index, 1);
      setAddTarifas([...arr]);
    },
    [addTarifas],
  );

  const getData = useCallback(async () => {
    try {
      setLoader(true);
      const responseDepartamento =
        await serviceDepto.DepartamentosService.getDepartamentos();
      await setDepartamentos(responseDepartamento.data.DepartamentoLista);

      const responseEmployee = await service.EmployeeService.getEmployeeId(id);

      setEmployee(responseEmployee.data.Funcionario);

      if (responseEmployee.data.Funcionario.Status === 'A') {
        setStatusChecked(true);
      } else {
        setStatusChecked(false);
      }
      const departamento = responseDepartamento.data.DepartamentoLista?.filter(
        (dep: Departamento) =>
          responseEmployee.data.Funcionario.CodDepartamento ===
          dep.CodigoDepartamento,
      ).map((dptoFiltrado: any) => {
        return setDepartamento(dptoFiltrado);
      });
      console.log({ departamento });
      const responseTarifas = await service.EmployeeService.getFares();
      await setTarifas(responseTarifas.data.ListaInformacoesDeTarifa);

      const tarifasDoFuncionario =
        responseTarifas.data.ListaInformacoesDeTarifa.filter(
          (tarifa: any) =>
            (responseEmployee.data.Funcionario.CodigoTarifa1 ===
              tarifa.CodigoDaTarifa &&
              responseEmployee.data.Funcionario.QuantidadeTarifa1 > 0) ||
            (responseEmployee.data.Funcionario.CodigoTarifa2 ===
              tarifa.CodigoDaTarifa &&
              responseEmployee.data.Funcionario.QuantidadeTarifa2 > 0) ||
            (responseEmployee.data.Funcionario.CodigoTarifa3 ===
              tarifa.CodigoDaTarifa &&
              responseEmployee.data.Funcionario.QuantidadeTarifa3 > 0) ||
            (responseEmployee.data.Funcionario.CodigoTarifa4 ===
              tarifa.CodigoDaTarifa &&
              responseEmployee.data.Funcionario.QuantidadeTarifa4 > 0),
        );
      await setTarifasDoFuncionario(tarifasDoFuncionario);
      setLoader(false);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    const runAsync = async function () {
      getData();
    };
    runAsync();
  }, [id]);

  const changedTarifas = useMemo(() => {
    const tarifas = tarifasDoFuncionario.map((item: any, index: any) => {
      const itemText = `QuantidadeTarifa${index + 1}`;
      const result = ts.transpile('employee[itemText]');
      const runnable: any = eval(result);
      const retorno: any = {
        tarifaName: item.CodigoDaTarifa,
        quantidade: runnable,
      };
      return retorno;
    });
    setAddTarifas(tarifas);
    return tarifasDoFuncionario;
  }, [tarifasDoFuncionario]);

  const getChangedTarifas = useCallback((data: any) => {
    return {
      CodigoTarifa1: data.length >= 1 ? String(data[0].tarifa) : '0',
      QuantidadeTarifa1: data.length >= 1 ? String(data[0].quantidade) : '0',
      CodigoTarifa2: data.length >= 2 ? String(data[1].tarifa) : '0',
      QuantidadeTarifa2: data.length >= 2 ? String(data[1].quantidade) : '0',
      CodigoTarifa3: data.length >= 3 ? String(data[2].tarifa) : '0',
      QuantidadeTarifa3: data.length >= 3 ? String(data[2].quantidade) : '0',
      CodigoTarifa4: data.length >= 4 ? String(data[3].tarifa) : '0',
      QuantidadeTarifa4: data.length >= 4 ? String(data[3].quantidade) : '0',
    };
  }, []);

  const handleSubmitForm = useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});

        setLoader(true);

        const tarifasData: any = formTarifasRef.current?.getData();

        const filteredTarifasData = Object.keys(tarifasData).length
          ? tarifasData.tarifas.filter((item: any) => !!item)
          : [];

        const ConvertedTarifas =
          Object.values(filteredTarifasData).length > 0
            ? getChangedTarifas(filteredTarifasData)
            : {
                CodigoTarifa1: null,
                QuantidadeTarifa1: '0',
                CodigoTarifa2: null,
                QuantidadeTarifa2: null,
                CodigoTarifa3: null,
                QuantidadeTarifa3: null,
                CodigoTarifa4: null,
                QuantidadeTarifa4: null,
              };

        await schema.validate(data, {
          abortEarly: false,
        });

        const StatusData = data.Status.length ? data.Status[0] : 'I';

        const changedCpf = data.FuncCpf.replace(/\D/g, '');

        const UpdateData = {
          ...data,
          CodigoFuncionario: id,
          CodigoDepartamento: data.CodigoDepartamento
            ? String(data.CodigoDepartamento)
            : null,
          Status: StatusData,
          FuncCpf: '' || changedCpf,
          CodigoTarifa1: ConvertedTarifas.CodigoTarifa1,
          CodigoTarifa2: ConvertedTarifas.CodigoTarifa2,
          CodigoTarifa3: ConvertedTarifas.CodigoTarifa3,
          CodigoTarifa4: ConvertedTarifas.CodigoTarifa4,
          QuantidadeTarifa1: ConvertedTarifas.QuantidadeTarifa1,
          QuantidadeTarifa2: ConvertedTarifas.QuantidadeTarifa2,
          QuantidadeTarifa3: ConvertedTarifas.QuantidadeTarifa3,
          QuantidadeTarifa4: ConvertedTarifas.QuantidadeTarifa4,
        };

        await service.EmployeeService.updateEmployee(UpdateData);
        setLoader(false);

        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Funcionário atualizado com sucesso!!',
        });
        getData();
      } catch (err: any) {
        setLoader(false);
        const { ...error } = err;

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          addToast({
            type: 'info',
            title: 'Erro de validação',
            description:
              'Por favor, verifique os campos do formulário, pois algum está inválido.',
          });
          return;
        }
        console.error('error', error);
        if (err.response.data) {
          if (err.response.status === 406) {
            if (err.response.data.Summary.ErrorCollection.SystemFailuresErros) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  err.response.data.Summary.ErrorCollection
                    .SystemFailureErros[0]?.InternalErrorMessage,
              });
            }
            if (err.response.data.Summary.ErrorCollection.DataValidationErros) {
              addToast({
                type: 'error',
                title: 'Erro ao atualizar',
                description:
                  err.response.data.Summary.ErrorCollection
                    .SystemFailureErros[0]?.InternalErrorMessage,
              });
            }
          }
          if (err.response.status === 500) {
            addToast({
              type: 'error',
              title: 'Erro ao atualizar',
              description: 'Servidor indisponível, tente novamente mais tarde',
            });
          }
        } else {
          addToast({
            type: 'error',
            title: 'Erro ao atualizar',
            description: 'Erro desconhecido ao atualizar',
          });
        }

        console.error(err);
      }
    },
    [schema, addToast],
  );

  const departamentoOptions = useMemo(() => {
    const changedDepartamentos = departamentos.map(
      (departamento: Departamento) => {
        return {
          value: departamento.CodigoDepartamento,
          label: departamento.Nome,
        };
      },
    );
    return changedDepartamentos;
  }, [departamentos]);

  const tarifasOptions = useMemo(() => {
    const changedTarifas = tarifas?.map((tarifa: any) => {
      return {
        value: tarifa.CodigoDaTarifa,
        label: tarifa.Descricao,
      };
    });
    return changedTarifas;
  }, [tarifas]);

  const handleAddTarifa = useCallback(() => {
    if (addTarifas.length < 4) {
      setAddTarifas([...addTarifas, { tarifaName: '', quantidade: 1 }]);
    }
  }, [addTarifas]);

  return (
    <Container>
      <>
        {loader && <Loader />}
        <Row className="titleWrapper">
          <Column small="2" medium="2" large="2">
            <IconContainer align="center">
              <HiOutlineUserGroup size={112} />
            </IconContainer>
          </Column>
          <Column small="10" medium="10" large="10" className="TitleContainer">
            <Title>
              Edição do Funcionário
              <Link to={`/funcionarios/${id}`}>
                <AiOutlineArrowLeft size={30} style={{ color: '#3F1159' }} />
              </Link>
            </Title>
            <SubTitle>
              Para fazer a recarga, é necessário que o seu cartão BHBUS esteja
              atrelado a algum funcionário. Aqui, você Edita as informações do
              funcionário que irá utilizar o cartão.
            </SubTitle>
          </Column>
        </Row>
        <Form ref={formRef} onSubmit={handleSubmitForm}>
          <Row className="CardContainer1">
            <Column small="2" medium="2" large="2">
              <InfoContainer className="infocontainer">
                <InfoItem className="infoitem">
                  <span className="info">&#9432;</span>
                  <span>
                    <b>Nome e Matrícula</b>&nbsp; são dados &nbsp;
                    <b>obrigatórios</b>&nbsp; para registro de funcionários.
                  </span>
                </InfoItem>
                <InfoItem className="infoitem">
                  <span className="info">&#9432;</span>
                  <span>
                    <b>Caso não haja um número de matrícula</b> para ser
                    cadastrado <b>utilize</b> o número do <b>CPF</b>.
                  </span>
                </InfoItem>
                <InfoItem>
                  <span className="info">&#9432;</span>
                  <span>
                    <b>
                      Em razão da LGPD, não é obrigatória a utilização do nome
                      completo do funcionário no campo "NOME". Pode inserir
                      apenas as iniciais de seu nome ou adotar outra informação
                      que atenda as necessidades internas da empresa.
                    </b>
                  </span>
                </InfoItem>
              </InfoContainer>
            </Column>
            <Column small="10" medium="10" large="10">
              <Card>
                <div className="CardTitle">Dados</div>
                <div className="CardForm">
                  <Row>
                    <Column small="12" medium="12" large="12">
                      <InputOutlined
                        name="Nome"
                        id="Nome"
                        schema={schema}
                        label="NOME"
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        defaultValue={employee?.Nome}
                        required
                      />
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <InputOutlined
                        name="FuncCpf"
                        id="FuncCpf"
                        schema={schema}
                        cpf
                        defaultValue={employee?.FuncCpf}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        label="CPF"
                        /*  required */
                      />
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <InputOutlined
                        name="Matricula"
                        id="Matricula"
                        schema={schema}
                        defaultValue={employee?.Matricula}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        label="MATRÍCULA"
                        required
                      />
                    </Column>
                    {/* <Column small="6" medium="6" large="6">
                      <InputOutlined
                        name="Salario"
                        schema={schema}
                        label="SALÁRIO"
                        defaultValue={employee?.Salario}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        type="number"
                      />
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <InputOutlined
                        name="Cargo"
                        schema={schema}
                        defaultValue={employee?.Cargo}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        label="CARGO"
                      />
                    </Column>
                    <Column small="6" medium="6" large="6" />
                    <Column small="6" medium="6" large="6">
                      <InputOutlined
                        name="Telefone"
                        schema={schema}
                        phone
                        defaultValue={employee?.Telefone}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        label="TELEFONE"
                      />
                    </Column> */}
                    <Column small="12" medium="12" large="12">
                      {departamento && (
                        <SelectOutLined
                          name="CodigoDepartamento"
                          options={departamentoOptions}
                          schema={schema}
                          label="DEPARTAMENTO"
                          defaultValue={{
                            value: departamento?.CodigoDepartamento,
                            label: departamento?.Nome,
                          }}
                          isDisabled={!statusChecked}
                          blocked={!statusChecked}
                          placeholder=""
                        />
                      )}
                      {!departamento && (
                        <SelectOutLined
                          name="CodigoDepartamento"
                          options={departamentoOptions}
                          schema={schema}
                          label="DEPARTAMENTO"
                          isDisabled={!statusChecked}
                          blocked={!statusChecked}
                          placeholder=""
                        />
                      )}
                    </Column>
                    <Column small="12" medium="12" large="12">
                      <Checkbox
                        name="Status"
                        checked={statusChecked}
                        onClick={() => setStatusChecked(!statusChecked)}
                        options={[
                          {
                            id: 'ativo',
                            value: 'A',
                            label: 'Ativo',
                          },
                        ]}
                      />
                    </Column>
                  </Row>
                </div>
              </Card>
            </Column>
          </Row>
          {/* <Row className="CardContainer">
            <Column small="2" medium="2" large="2">
              <InfoContainer />
            </Column>
            <Column small="10" medium="10" large="10">
              <Card>
                <div className="CardTitle">Endereço</div>
                <div className="CardForm">
                  <Row>
                    <Column small="4" medium="4" large="4">
                      <InputOutlined
                        name="Cep"
                        schema={schema}
                        cep
                        defaultValue={employee?.CEP}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        label="CEP"
                      />
                    </Column>
                  </Row>
                  <Row>
                    <Column small="12" medium="12" large="12">
                      <InputOutlined
                        name="Endereco"
                        schema={schema}
                        defaultValue={employee?.Endereco}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        label="RUA E NÚMERO"
                      />
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <InputOutlined
                        name="Bairro"
                        schema={schema}
                        defaultValue={employee?.Bairro}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        label="BAIRRO"
                      />
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <InputOutlined
                        name="Municipio"
                        schema={schema}
                        defaultValue={employee?.Municipio}
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        label="CIDADE"
                      />
                    </Column>
                  </Row>
                </div>
              </Card>
            </Column>
            </Row> */}
          <Row className="CardContainer">
            <Column small="2" medium="2" large="2">
              <InfoContainer
                style={{ cursor: 'pointer' }}
                onClick={() => setShowTarifas(true)}
              >
                <InfoItem className="infoitem">
                  <span className="info">&#9432;</span>
                  Clique aqui para consultar sobre os tipos de tarifa.
                </InfoItem>

                <InfoItem className="infoitem">
                  <span className="info">&#9432;</span>
                  Nesta seção, preencha a quantidade de passagens que este
                  funcionário utiliza durante 1 dia útil. Após isso, na tela de
                  Pedidos de Recarga &gt; Recarga por dia, o sistema irá
                  calcular exatamente quanto esse funcionário utiliza de vale
                  transporte por dia.
                </InfoItem>
              </InfoContainer>
            </Column>
            <Column small="10" medium="10" large="10">
              <Card style={{ minHeight: '96%' }}>
                <div className="CardTitle">Tarifas por dia</div>
                <div className="CardForm">
                  <Form
                    ref={formTarifasRef}
                    onSubmit={handleSubmitForm}
                    className="TarifasForm"
                  >
                    {addTarifas.map((tarifa: any, index: any) => (
                      <>
                        {tarifa.quantidade > 0 && (
                          <Row key={`key${index + 1}`}>
                            <Column
                              small="6"
                              medium="6"
                              large="6"
                              className="tarifaOptions"
                            >
                              <SelectOutLined
                                name={`tarifas[${index}].tarifa`}
                                options={tarifasOptions}
                                label={`Tarifa ${index + 1}`}
                                defaultValue={{
                                  value: tarifa.tarifaName,
                                  label: tarifasDoFuncionario?.filter(
                                    (tarif: any) =>
                                      tarif.CodigoDaTarifa ===
                                      tarifa.tarifaName,
                                  )[0]?.Descricao,
                                }}
                                isDisabled={!statusChecked}
                                blocked={!statusChecked}
                                placeholder="Selecione a tarifa"
                              />
                            </Column>
                            <Column
                              small="5"
                              medium="5"
                              large="5"
                              className="tarifaOptions"
                            >
                              <InputOutlined
                                name={`tarifas[${index}].quantidade`}
                                type="number"
                                min="1"
                                defaultValue={tarifa.quantidade}
                                disabled={!statusChecked}
                                blocked={!statusChecked}
                                label={`Qtd. da tarifa ${index + 1}`}
                              />
                            </Column>
                            <Column
                              small="1"
                              medium="1"
                              large="1"
                              className="tarifaOptions"
                            >
                              {index >= 0 && (
                                <Button
                                  color="red"
                                  type="button"
                                  padding="1"
                                  blocked={!statusChecked}
                                  onClick={() => handleRemoveTarifa(index)}
                                >
                                  <FaTrash />
                                </Button>
                              )}
                            </Column>
                          </Row>
                        )}
                      </>
                    ))}
                    {addTarifas.length <= 3 && (
                      <Button
                        color="purple"
                        type="button"
                        rounded
                        padding="2"
                        disabled={!statusChecked}
                        blocked={!statusChecked}
                        onClick={() => handleAddTarifa()}
                      >
                        ADICIONAR TARIFA
                      </Button>
                    )}
                  </Form>
                </div>
              </Card>
              <div className="buttonsContainer">
                <Link to={`/funcionarios/${id}`} className="cancel">
                  CANCELAR
                </Link>
                <Button color="orange" padding="1" rounded type="submit">
                  SALVAR EDIÇÃO
                </Button>
              </div>
            </Column>
          </Row>
        </Form>
        {showTarifas && (
          <TarifasModal
            show={showTarifas}
            title="Tarifas"
            handleClose={() => setShowTarifas(false)}
          />
        )}
      </>
    </Container>
  );
};

export default EditEmployee;
